import { Component, Input, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { differenceInMilliseconds, formatISO } from 'date-fns';
import { BehaviorSubject } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'om-date-input',
  templateUrl: './om-date-input.component.html',
  styleUrls: ['./om-date-input.component.scss']
})
export class OmDateInputComponent implements OnInit{

  @Input() control: FormControl = new FormControl();
  @Input() disabled: boolean = false;
  @Input() placeholder = '';

  @Input() label: string;
  @Input() icon: string;

  @Input() dateFormat = '';
  @Input() onlyFuture = false;
  @Input() showTime: (object | boolean) = false;
  @Input() allowClear: boolean = true;

  @Input() disabledDate: (currentDate: Date) => boolean = null;

  isRequired$ = new BehaviorSubject<boolean>(false);
  _control = new FormControl();

  constructor() { }

  ngOnInit(): void {
    
    if (this.control.hasValidator(Validators.required)) {
      this.isRequired$.next(true);
      this._control.addValidators(Validators.required);
    }
    if (this.control.disabled) {
      this._control.disable();
    }
    this._control.setValue(this.control.value);
    this._control.valueChanges.pipe(
      distinctUntilChanged((prev, curr) => differenceInMilliseconds(prev, curr) === 0),
      untilDestroyed(this),
    ).subscribe(value => {
      const valueAsDate = (value: Date | string) => value instanceof Date ? value : new Date(value);
      const dateString = value ? formatISO(valueAsDate(value), { representation: this.showTime || this.dateFormat.includes('HH:mm') ? 'complete' : 'date' }) : null;
      this.control.setValue(dateString);
      this.control.markAsDirty();
    });
    this.control.registerOnChange(value => this._control.setValue(value, {emitEvent: false}));
    this.control.registerOnDisabledChange(isDisabled => {
      if (isDisabled) {
        return this._control.disable({emitEvent: false});
      } else {
        this._control.enable({emitEvent: false});
      }
    })
  }

  _disabledDate = (currDate: Date) => {
    if (this.disabledDate) return this.disabledDate(currDate);
    
    if (this.onlyFuture === true) {   
      const date = new Date();
      date.setHours(0, 0, 0, 0);
      return date.getTime() > currDate.getTime();
    }
    return false;
  }

  onOpenChange(evt: boolean) {
    if (!evt && !this._control.value && this.isRequired$.value) {
      this._control.markAsTouched();
      this._control.markAsDirty();
      this.control.markAsTouched();
      this.control.markAsDirty();
    }
  }
}
